export class ApiError {
  Field: string;
  ErrorCode: string;
  ErrorMessage: string;
}
